import classNames from 'classnames'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

interface SwitchProps {
  leftLabel?: string
  rightLabel?: string
  name: string
  value: boolean
  onChange: (value: boolean) => void
}

const Switch = ({
  leftLabel,
  rightLabel,
  name,
  value,
  onChange,
}: SwitchProps) => {
  const { t } = useTranslation();

  const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked)
  }

  if (leftLabel) {
    return (
      <div className="flex justify-between items-center w-full px-3 py-2 cursor-pointer hover:bg-blue-100">
        <span className="text-sm text-gray-700">{t(leftLabel)}</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            name={name}
            type="checkbox"
            checked={value}
            onChange={handleToggle}
            className="sr-only"
          />
          <div
            className={classNames(
              'w-14 h-8 sm:w-10 sm:h-6 rounded-full shadow-inner transition-colors duration-200',
              value ? 'bg-imovPrimary' : 'bg-gray-300'
            )}
          >
            <div
              className={classNames(
                'absolute top-1 left-1 w-6 h-6 sm:w-4 sm:h-4 rounded-full bg-white shadow transform transition-transform duration-200',
                value ? 'translate-x-6 sm:translate-x-4 bg-blue-500' : ''
              )}
            />
          </div>
        </label>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-blue-100">
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          name={name}
          type="checkbox"
          checked={value}
          onChange={handleToggle}
          className="sr-only"
        />
        <div
          className={classNames(
            'w-14 h-8 sm:w-10 sm:h-6 rounded-full shadow-inner transition-colors duration-200',
            value ? 'bg-imovPrimary' : 'bg-gray-300'
          )}
        >
          <div
            className={classNames(
              'absolute top-1 left-1 w-6 h-6 sm:w-4 sm:h-4 rounded-full bg-white shadow transform transition-transform duration-200',
              value ? 'translate-x-6 sm:translate-x-4 bg-blue-500' : ''
            )}
          />
        </div>
      </label>
      {rightLabel && (
        <span className="text-sm text-gray-700">{t(rightLabel)}</span>
      )}
    </div>
  )
}

export default Switch
